import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { DarkModeToggle } from "../ui";

export function CGU() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-slate-100 dark:bg-slate-900 text-gray-900 dark:text-white">
      <div className="absolute top-4 right-4 z-20 flex items-center gap-4">
        <DarkModeToggle />
        <Link
          to="/"
          className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
        >
          <ArrowLeft size={18} />
          {t("legal.back")}
        </Link>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold mb-8">{t("legal.cgu")}</h1>
        <div className="prose prose-slate dark:prose-invert max-w-none space-y-4 text-gray-600 dark:text-slate-300">
          <p>
            Les présentes Conditions générales d&apos;utilisation (CGU) régissent l&apos;accès et l&apos;utilisation
            du service Régie Connect. En utilisant ce service, vous acceptez ces conditions.
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Objet du service</h2>
          <p>
            Régie Connect est une solution de gestion pour professionnels de l&apos;éclairage LED (dossiers clients,
            stock, planification, équipe). L&apos;accès au service est soumis à un abonnement.
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Engagements de l&apos;utilisateur</h2>
          <p>
            L&apos;utilisateur s&apos;engage à fournir des informations exactes, à ne pas utiliser le service
            à des fins illicites et à respecter les droits des tiers. Il est responsable de la confidentialité
            de ses identifiants.
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Résiliation</h2>
          <p>
            L&apos;utilisateur peut résilier son abonnement selon les modalités prévues. L&apos;éditeur se réserve
            le droit de suspendre ou résilier l&apos;accès en cas de manquement aux présentes CGU.
          </p>
          <p className="mt-8 text-sm text-gray-500 dark:text-slate-400">
            [Texte à adapter avec un conseil juridique pour votre activité.]
          </p>
        </div>
      </div>
    </div>
  );
}
